

// firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAvsE_7JRF1Qy0qlRKYr0JSHVF20uLDY6E",
  authDomain: "propertygroupapp-66ae9.firebaseapp.com",
  projectId: "propertygroupapp-66ae9",
  storageBucket: "propertygroupapp-66ae9.firebasestorage.app",
  messagingSenderId: "312880530194",
  appId: "1:312880530194:web:5b101b33e2a91ccab269cb",
  measurementId: "G-5W7SS28BXT"
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

export { firebaseApp, auth, db, storage };











